<template>
  <section>
    <r-title>{{ $t("title") | titlecase }}</r-title>
    <template v-if="isCustomerUser">
      <r-title :level="2">{{ $t("tasks.open") | titlecase }}</r-title>
      <TaskList
        :tasks="uploadedTasks"
        show-state
        show-upload-date
        show-action
      />

      <r-title :level="2">{{ $t("tasks.finished") | titlecase }}</r-title>
      <TaskList :tasks="finishedTasks" show-finish-date />
    </template>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import TaskList from "@/components/TaskList.vue";

export default {
  name: "Home",
  components: {
    TaskList
  },
  i18nOptions: {
    keyPrefix: "views.home"
  },
  inject: {
    authStore: "authStore"
  },
  computed: {
    isCustomerUser() {
      return this.authStore.hasRole("rvkCustomerUser");
    },
    ...mapGetters(["uploadedTasks", "finishedTasks"])
  },
  created() {
    if (this.isCustomerUser) {
      this.$store.dispatch("loadUploadedTasks");
      this.$store.dispatch("loadFinishedTasks");
    }
  }
};
</script>
